import { Exclude, Expose, Type } from 'class-transformer'

import { StickerType } from './StickerType'

@Exclude()
export class GetStickerListResponse {
  @Expose()
  @Type(() => StickerType)
  data: StickerType[]

  @Expose() total: number

  @Expose() page: number
}
